// OWNER: AREA-TEMPLATES (templates/*, partials/*, assets/*). Components go in src/features/assets.
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { assetQuery } from '@/features/assets/api'
import { AssetDetailPage } from '@/features/assets/AssetDetailPage'
import { IdCrumb } from '@/shell/crumbs'

function AssetCrumb({ params }: { params: Record<string, string> }) {
  const id = params.assetId ?? ''
  const q = useQuery({ ...assetQuery(id), enabled: !!id })
  return q.data ? <span className="font-mono text-xs">{q.data.key}</span> : <IdCrumb value={id} />
}

export const Route = createFileRoute('/assets/$assetId')({
  staticData: { crumb: AssetCrumb },
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(assetQuery(params.assetId))
  },
  component: AssetPage,
})

function AssetPage() {
  const { assetId } = Route.useParams()
  return <AssetDetailPage assetId={assetId} />
}
